import React from "react"
import { Container, Row, Col } from "reactstrap"
import { Link } from "react-router-dom"

const Footer = () => {
  return (
    <React.Fragment>
      <footer className="footer">
        <Container fluid={true}>
          <Row>
            <Col md={6}>
              {new Date().getFullYear()} © Porcher.
              <a href="tel:+17028991226" className="text-decoration-none ms-3">702-899-1226</a>
            </Col>
            <Col md={6}>
              <div className="text-sm-end d-none d-sm-block">
                <Link to="/rentals" className="text-decoration-none me-3">Rentals</Link>
                <Link to="/terms-of-service" className="text-decoration-none me-3">Terms of Service</Link>
                <Link to="/privacy-policy" className="text-decoration-none">Privacy Policy</Link>
              </div>
            </Col>  
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  )
}

export default Footer
